import { Child } from '@football-kids/shared/entity/Child';
import { Group } from '@football-kids/shared/entity/Group';
import Color from 'color';
import { pipe } from 'pipe-ts';
import { upperCase } from './string';
import { School } from '@football-kids/shared/entity/School';
// "hsl(" + 360 * Math.random() + ',' +
// (25 + 70 * Math.random()) + '%,' +
// (85 + 10 * Math.random()) + '%)'


export const stringToEmoji = (string: string) => {
    const arr = [
        `🐶`,
        `🐱`,
        `🐭`,
        `🐹`,
        `🐰`,
        `🦊`,
        `🐻`,
        `🐼`,
        `🐨`,
        `🐯`,
        `🦁`,
        `🐮`,
        `🐸`,
        `🐵`,
        `🌸`,
        `⚽`,
        `❤️`,
        `🩷`,
        `🧡`,
        `💛`,
        `💚`,
        `💙`,
        `🩵`,
        `💜`,
        `🖤`,
        `🩶`,
        `🤍`,
        `🤎`,
        `🍊`,
        `🍋`,
        `🍓`,
        `🫐`,
        `🍈`,
        `🍒`,
        `🍔`,
        `🍟`,
        `🍕`,
        'X', 'X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X','X',
    ];
    const r = Math.floor(Math.random() * arr.length);
    return `${arr[r]}`;
};

export function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

// saturation in range 25-95% and lightness in range 85-95%:
const toPastel = (arg: string) => {
    const color = new Color(arg);
    const [hue, _saturation, _lightness] = color.hsl().round().array();
    const r = new Color([hue, 75, 90], 'hsl').rgb().round().string();
    return r;
};

export const tint = (colorArg: string, level = 8) => {
    const color = new Color(colorArg);
    const [hue, saturation, lightness] = color.hsl().round().array();
    const r = new Color([hue, saturation, lightness + level], 'hsl').rgb().round().string();
    return r;
}

const darken = (colorArg: string, level = 8) => {
    const color = new Color(colorArg);
    const [hue, saturation, _lightness] = color.hsl().round().array();
    const r = new Color([hue, saturation, 37], 'hsl').rgb().round().string();
    return r;
}

export const childToColor = (child: Child) =>
    pipe(
        upperCase,
        stringToColor,
        toPastel
    )(`${child.name} ${child.surname}`);

export const groupToColor = (groupId: Group['id']) =>
    pipe(upperCase, stringToColor, toPastel)(groupId);

export const schoolToColor = (schoolId: School['id']) =>
    pipe(upperCase, stringToColor, darken)(schoolId);
